export function devisRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_ACTION_START":           
        case "ASK_DEVIS_START":           
        case "GET_ALL_DEVIS_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_ACTION_FULFILLED":           
        case "ASK_DEVIS_FULFILLED":           
        case "GET_ALL_DEVIS_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_ACTION_ERROR":
        case "ASK_DEVIS_ERROR":
        case "GET_ALL_DEVIS_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}